/**
 * Gemeinsame Gäste-Typen.
 *
 * Geteilt von der Gästekarten-Verwaltung und `GuestDetailModal` (u. a. vom
 * Vorstands-Dashboard aus geöffnet).
 */

export interface GuestCardType {
  id: number;
  name: string;
  total_entries: number;
  price: number;
  start_date: string;
  end_date: string;
  is_active: boolean;
}

export interface GuestCard {
  id: number;
  guest_card_type_id: number;
  member_id: string;
  remaining_entries: number;
  total_entries?: number;
  purchase_date: string;
  expiry_date: string;
  is_active?: boolean;
  bezahlt?: boolean;
  bezahlt_am?: string | null;
  type?: GuestCardType;
  card_name?: string;
  /** Buchungen der Karte; Form wie von /api/guest-cards/guest-cards geliefert. */
  bookings?: any[];
  name?: string;
}

export interface Guest {
  mg_nr: string;
  mitglied_nr: string;
  name: string;
  vorname: string;
  email: string;
  tel_nummer?: string;
  eintritt?: string;
  foto_path?: string | null;
  foto_path_updated?: string | number | null;
  last_login: string | null;
  last_booking: string | null;
  cards: any[];
}

/**
 * Mindestangaben, um das Detail-Modal zu öffnen. Karten und Buchungen lädt das
 * Modal selbst nach — Aufrufer wie das Dashboard kennen nur Name und Nummer.
 */
export interface GuestRef {
  mg_nr: string;
  vorname: string;
  name: string;
  mitglied_nr?: string;
  email?: string;
  tel_nummer?: string;
  eintritt?: string;
  foto_path?: string | null;
  foto_path_updated?: string | number | null;
  last_login?: string | null;
  last_booking?: string | null;
}

/**
 * Stornierbarkeit einer Gastbuchung.
 *
 * Regel: bis zum Eventbeginn und danach noch 24 Stunden lang möglich.
 */
export function getCancellationStatus(booking: {
  start?: string;
  start_time?: string;
}): { allowed: boolean; reason?: string } {
  const eventDateTime = new Date(`${booking.start}T${booking.start_time || '00:00'}`);
  const now = new Date();
  const hoursSinceEvent = (now.getTime() - eventDateTime.getTime()) / (1000 * 60 * 60);
  const canCancel = eventDateTime > now || hoursSinceEvent <= 24;
  return {
    allowed: canCancel,
    reason: canCancel ? undefined : 'Stornierung nur bis 24h nach dem Event möglich',
  };
}

/** Initialen als Avatar-Fallback (z. B. „AB"). */
export function guestInitials(guest: { vorname?: string; name?: string }): string {
  return `${guest.vorname?.[0] ?? ''}${guest.name?.[0] ?? ''}`.toUpperCase() || '?';
}
